
import axios from 'axios'
class Usage {
  constructor () {
    this.license = ''
    this.isTrial = true
    this.licenseId = ''
    this.licenseStatus = 1
    this.monday = []
    this.val = null
    this.deviceId = ''
    this.machineName = ''
    this.machineUserName = ''
    this.version = ''
    this.publisher = ''
  }

  toJSON () {
    return { ...this }
  }
}
class SwebScanAnalytics {
  constructor () {
    this.enabled = true
    this.service = 'https://webscan.si/api/analytics/usage' // 'https://mobilescan.solumainvoicereader.com:3040/api/analytics/usage'
    // this.service = 'http://localhost:9100/api/analytics/usage'
    this.license = ''
    this.licenseId = ''
    this.isTrial = true
    this.monday = []
    this.licenseStatus = 1
    this.deviceId = ''
    this.machineName = ''
    this.machineUserName = ''
    this.version = ''
    this.publisher = ''
  }

  setLicenseStatus = (val) => {
    this.licenseStatus = val
  }

  setTrial = (val) => {
    this.isTrial = val
  }

  setLicense = (val) => {
    this.license = val
  }

  setLicenseId = (val) => {
    this.licenseId = val
  }

  setDeviceId = (val) => {
    this.deviceId = val
    console.log('SetDeviceID', val)
  }

  setMachineName = (val) => {
    this.machineName = val
  }

  setMachineUserName = (val) => {
    this.machineUserName = val
  }

  setVersion = (val) => {
    this.version = val
  }

  setPublisher = (val) => {
    this.publisher = val
  }

  setMonday = (val) => {
    this.monday.push(val)
  }

  enableEmit = (val) => {
    this.enabled = val
  }

  serviceUrl = (val) => {
    this.service = val
  }

  setupUsage = async () => {
    const usage = new Usage()
    usage.licenseStatus = this.licenseStatus
    usage.license = this.license
    usage.isTrial = this.isTrial
    usage.licenseId = this.licenseId
    usage.monday = this.monday
    usage.deviceId = this.deviceId
    usage.machineName = this.machineName
    usage.machineUserName = this.machineUserName
    usage.version = this.version
    usage.val = {}
    return usage
  }

  emitClick = async (property) => {
    if (!this.enabled) { return }
    try {
      const obj = await this.setupUsage()
      obj.val.p = 'click' + '.' + property
      obj.val.t = '$inc'
      obj.val.v = 1
      this.execute(obj)
    } catch (err) {
      /// catch error
      console.log('SwebScanAnalytics.emitClick Error', err)
    }
  }

  emitProcess = async (property) => {
    if (!this.enabled) { return }
    try {
      const obj = await this.setupUsage()
      obj.val.p = 'process' + '.' + property
      obj.val.t = '$inc'
      obj.val.v = 1
      this.execute(obj)
    } catch (err) {
      /// catch error
      console.log('SwebScanAnalytics.emitProcess Error', err)
    }
  }

  execute = async (obj) => {
    if (!this.enabled) { return }
    try {
      const resp = await axios.post(this.service, obj)
      console.log(resp)
    } catch (err) {
      console.log(err)
    }
  }

  install = (Vue, options) => {
    // console.log('install SwebScanAnalytics plugin')
    Vue.prototype.$swsa = this
  }
}

const swsa = new SwebScanAnalytics()
export default swsa
